import React from 'react';
import { Card, List, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Meta } = Card;

function CouponItemCard() {
  return (
    <Card>
      <Meta
        title="Get 20% discount using ABC Bank Credit Cards"
        description="Use code 100INDUSIND & get 20% discount up to Rs.100 on orders above Rs.400"
      />
      <List itemLayout="horizontal">
        <List.Item>
          <List.Item.Meta
            description={
              <div style={{ display: 'flex', fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <Button
                    type="link"
                    icon={<PlusOutlined />}
                    style={{ padding: 0 }}
                  >
                    More
                  </Button>
                </div>
              </div>
            }
          />
        </List.Item>
        <List.Item>
          <List.Item.Meta
            description={
              <div style={{ display: 'flex', fontSize: 12 }}>
                <div style={{ flex: 1, color: '#8a584b', fontWeight: 600 }}>
                  <Button danger>Copy Code</Button>
                </div>
              </div>
            }
          />
        </List.Item>
      </List>
    </Card>
  );
}

export default CouponItemCard;
